import { useTheme } from '@sds-system/system';
import type { ColorCode } from '@sds-system/types';
import { getColorValue } from '@sds-system/utils';
import { getSpinnerId } from './Spinner.const';
import type { SpinnerProps } from './Spinner.types';

export const SpinnerRoundCharge = ({ color, variant, name, ...props }: SpinnerProps) => {
  const theme = useTheme();
  const { palette } = theme;

  const svgColor = getColorValue((color || palette.bg.interactive.primary) as ColorCode, theme);

  const animateIdList = getSpinnerId(2, variant, name);

  return (
    <svg
      fill='none'
      height='40'
      viewBox='0 0 40 40'
      width='40'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M20 3
       a 17 17 0 1 0 0.00001 0'
        stroke={svgColor}
        strokeDasharray='106.76'
        strokeLinecap='round'
        strokeWidth='6'
        transform='rotate(90 20 20)'
      >
        <animate
          attributeName='stroke-dashoffset'
          begin={animateIdList[0]?.begin}
          dur='0.6s'
          from='-106.76'
          id={animateIdList[0]?.id}
          to='0'
        />
        <animate
          attributeName='stroke-dashoffset'
          begin={animateIdList[1]?.begin}
          dur='0.6s'
          from='0'
          id={animateIdList[1]?.id}
          to='106.76'
        />
      </path>
    </svg>
  );
};
